const expects = [
  { icon: 'ri-music-2-line',    title: 'Powerful Worship',          desc: 'Songs of revival that usher in the presence of God',                   featured: true },
  { icon: 'ri-book-open-line',  title: 'Word of God',           desc: 'Preaching that ignites faith and transforms hearts',                    featured: false },
  { icon: 'ri-heart-pulse-line',title: 'Prayer & Encounter',        desc: 'Moments of personal encounter with the living God',                    featured: false },
  { icon: 'ri-fire-line',       title: 'Youth Revival Atmosphere',  desc: 'A room alive with young people hungry for God',                        featured: true },
  { icon: 'ri-group-line',      title: 'SHAY Team Worship',         desc: 'A team carrying the fire of revival for this generation',              featured: false },
  { icon: 'ri-star-smile-line', title: 'Skits & Creative Ministry', desc: 'Creative expressions that speak powerfully to this generation',        featured: false },
  { icon: 'ri-sparkling-2-line',title: 'Presence of God',           desc: 'An atmosphere where God moves, heals, and restores',                  featured: true },
  { icon: 'ri-links-line',      title: 'Community & Connection',    desc: 'Connect with others who carry the same fire and hunger',               featured: false },
];

const WhatToExpect = () => {
  return (
    <section
      id="what-to-expect"
      className="relative py-28 px-6 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0e0e0e 0%, #090909 100%)' }}
    >
      {/* Ambient center glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: '700px',
          height: '500px',
          background: 'radial-gradient(ellipse, rgba(212,168,66,0.055) 0%, transparent 65%)',
        }}
      />
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.4), transparent)' }}
      />

      <div className="max-w-2xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 mb-7 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
            style={{ background: 'rgba(212,168,66,0.1)', border: '1px solid rgba(212,168,66,0.35)', color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            <span>✦</span> Experience
          </div>
          <h2
            className="font-black uppercase mb-4"
            style={{
              fontFamily: "'Glacial Indifference', sans-serif",
              fontSize: 'clamp(2rem, 7vw, 3.2rem)',
              color: '#FFFFFF',
              textShadow: '0 0 40px rgba(212,168,66,0.2)',
            }}
          >
            What to Expect
          </h2>
          <p className="text-sm md:text-base max-w-sm mx-auto leading-relaxed" style={{ color: '#888', fontFamily: "'Glacial Indifference', sans-serif" }}>
            A gathering that touches every part of who you are — spirit, soul, and purpose.
          </p>
        </div>

        <div className="flex flex-col gap-0">
          {expects.map((item, idx) => (
            <div key={item.title}>
              <div
                className="group flex items-start gap-5 py-5 px-4 transition-all duration-300 hover:bg-white/[0.018] cursor-default relative"
                style={{
                  borderLeft: `2px solid ${item.featured ? '#D4A842' : 'rgba(212,168,66,0.22)'}`,
                }}
              >
                {item.featured && (
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{ background: 'linear-gradient(90deg, rgba(212,168,66,0.05) 0%, transparent 60%)' }}
                  />
                )}
                <div
                  className="w-9 h-9 flex items-center justify-center flex-shrink-0 relative z-10"
                  style={{ color: item.featured ? '#F5D060' : '#9A7520' }}
                >
                  <i className={`${item.icon} text-xl`} />
                </div>
                <div className="relative z-10 pt-0.5">
                  <h4
                    className="font-bold mb-1"
                    style={{
                      fontFamily: "'Glacial Indifference', sans-serif",
                      fontSize: '0.82rem',
                      color: item.featured ? '#FFFFFF' : '#CCCCCC',
                      letterSpacing: '0.06em',
                    }}
                  >
                    {item.title}
                  </h4>
                  <p className="text-xs leading-relaxed" style={{ color: '#666', fontFamily: "'Glacial Indifference', sans-serif" }}>
                    {item.desc}
                  </p>
                </div>
              </div>
              {idx < expects.length - 1 && (
                <div
                  className="h-px ml-4"
                  style={{ background: 'rgba(212,168,66,0.08)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatToExpect;
